import 'semantic-ui-css/semantic.min.css'
import { React, useEffect, useState } from 'react';
//import data from './' + process.env.PUBLIC_URL + '/data/epublicaties.json'
import { Container, Segment , Header ,Checkbox , Divider , Icon , Popup , Button } from 'semantic-ui-react';
//const pub = process.env.PUBLIC_URL
import './translations/i18n';
import { useTranslation  } from 'react-i18next';

const icons = {
    E_BOOK : 'book',
    E_TIJDSCHRIFT : 'address book',
    WEBSITE : 'globe',
    E_DATABANK : 'computer',
    E_HANDBOEK : 'book',
    KRANT : 'newspaper',
    E_PLATFORM : 'keyboard',
    E_DOCUMENT : 'file',
    MULTIMEDIA : 'play'
}

const showFilters = [
    'uitgelicht',
    'uitgavenvorm',
    'domein',
]

const Filters = ({ filters : selectedFilters , filterCount : filterCounterData , onChange : onChange }) => {
    const handleToggle = ( e, { value , checked }) => {
        onChange({value,checked})
    }
    const maxFiltersDefault = 10
    const { t , i18n } = useTranslation();
    const [ showMore , setShowMore ] = useState({})
    useEffect(() => {
        Object.keys(selectedFilters).map((filterGroep) => {
            setShowMore(obj => ({...obj , [filterGroep] : false }))
        })
    },[])
    return (
        <Container>
            {
                showFilters.map((filter) => {
                    
                    let sortable = [];
                    for (var f in selectedFilters[filter]) {
                        sortable.push([f, selectedFilters[filter][f]]);
                    }
                    sortable.sort(function(a, b) {
                        return b[1] - a[1];
                    });
                    let spl = showMore[filter] ? selectedFilters[filter].length : maxFiltersDefault < sortable.filter(i => i[1] === true ).length ? sortable.filter(i => i[1] === true ).length : maxFiltersDefault
                    
                    return <Segment>
                        <Header>{t(`${filter}`) + ' '}
                        {(sortable.filter(i => i[1] === true ).length > 0) &&  
                            <span onClick={() => {
                                console.log()
                            }}>({sortable.filter(i => i[1] === true ).length})</span>
                            }
                        </Header>
                        <Divider />
                        
                        {filterCounterData[filter].slice(0,spl).map((v,k) => {
                            return <Checkbox label={t(`taxonomieItems.${v.value}`)} value={{filterGroep : filter, veld : v.value}} style={{display:'block'}} onChange={handleToggle} checked={selectedFilters[filter][v.value]}  />
                        })}
                        {Object.keys(selectedFilters[filter]).length > maxFiltersDefault &&
                                <a style={{cursor : 'pointer'}} onClick={() => {
                                    setShowMore(obj => ({...obj , [filter] : !obj[filter] }))
                                }}>{showMore[filter] ? t('showLess') : t('showMore')}</a>
                            }
                    </Segment>
                })
                
            }
        </Container>
    );
}

export default Filters;